import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer/Footer";
import { isAuthenticated } from "./utils/auth";
import { getBranchDataService } from "./API/branchApi";
import Bookings from "./pages/Bookings/Bookings";
import ContactUs from "./pages/contactus/ContactUs";
import Spinner from "./components/Spinner";
import BookingView from "./components/BookingView";
import RoomThankyou from "./pages/roomBooking/RoomThankyou";
import LogIn from "./pages/Login/LogIn";
import MyAccount from "./pages/myaccount/MyAccount";
import RoomThankYouPage from "./components/BookingView/Room/RoomThankYouPage";
import Dashboard from "./pages/myaccount/Dashboard";
import Map from "./pages/Map";
import { getHotelPolicy } from "./API/policyApi";
import { branchData } from "./API/loginApi";

const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/" replace />;
};

export default function App() {
  const path = window.location.pathname;
  const pageName = path.split("/")[1];

  const [hotelPolicyData,setHotelPolicyData] = useState({})
  const [landingDetail, setLandingDetail] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [branchDataRes, setBranchDataRes] = useState([]);

  let typeUser = localStorage.getItem("typeuser");
  const branchName = pageName ? pageName :  localStorage.getItem("branchname") || "spinnakeratlakedillon";

  const loadData = async () => {
    try {
      setIsLoading(true);
      const res = await getBranchDataService(pageName);
      setLandingDetail(res?.data?.[0]);
      localStorage.setItem("locale", res?.data?.[0]?.locale);
      localStorage.setItem("_authkey", res?.data?.[0]?.authkey);
      localStorage.setItem("Currency", res?.data?.[0]?.currency);
      localStorage.setItem("branchid", res?.data?.[0]?._id);
      localStorage.setItem("branchname", res?.data?.[0]?.shortname || "spinnakeratlakedillon");

      const data = await getHotelPolicy();
      setHotelPolicyData(data);


      const branchRes = await branchData()
      setBranchDataRes(branchRes?.data?.[0])

      localStorage.setItem("timezone", branchRes?.data?.[0]?.timezone)

    } catch (error) {
      setIsLoading(false);
      console.error("error::: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {

    if (!localStorage.getItem("branchname")) {
      localStorage.setItem("branchname", "spinnakeratlakedillon"); // Ensure branchName is set
    }
    loadData();
  }, []);

  const setDefaultBookingDates = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    // Set time to midnight UTC (00:00:00.000Z)
    today.setUTCHours(0, 0, 0, 0);
    tomorrow.setUTCHours(0, 0, 0, 0);

    const checkIn = localStorage.getItem("checkInDate");
    const checkOut = localStorage.getItem("checkOutDate");

    if (!checkIn || !checkOut) {
      localStorage.setItem("checkInDate", today.toISOString());
      localStorage.setItem("checkOutDate", tomorrow.toISOString());
    }
  };

  useEffect(() => {
    setDefaultBookingDates();
  }, []);

  if (!branchName || branchName === "undefined") {
    localStorage.clear()
    return <Navigate to="/spinnakeratlakedillon" replace />; // Redirect to default branch
  }


  if (loading) {
    return <Spinner />;
  }



  if(landingDetail === undefined || landingDetail?.authkey === undefined || landingDetail?.authkey === null){
    localStorage.removeItem("branchid")
    localStorage.removeItem("_authkey")
    localStorage.removeItem("authkey")
    localStorage.removeItem("branchname")
    localStorage.removeItem("Currency")
  }

  if (!Object.keys(landingDetail)?.length) {
    return <div>No data available for the selected branch.</div>; // Fallback UI
  }

  console.log('landingDetail::: ', landingDetail);


  return (
    <>
      <Helmet>
        <title>{landingDetail?.branchname}</title>
         <link rel="icon" href={landingDetail?.logo} />
         <link rel="apple-touch-icon" href={landingDetail?.logo}  />
      </Helmet>
      {/* {loading && <Spinner />} */}
      <ToastContainer />
      <Router>
        <Navbar
          hotelPolicyData={hotelPolicyData}
          branchDataRes={branchDataRes}
          setNavData={
            landingDetail?.menu === undefined ? "" : landingDetail?.menu
          }
          logo={landingDetail?.logo === undefined ? "" : landingDetail?.logo}
          allData={landingDetail}
        />
        <Routes>
          {/* Public Routes */}
          <Route
            path={"/" + branchName + "/sign-in"}
            element={<LogIn setLandingData={landingDetail} />}
          />
          <Route
            path={"/" + branchName}
            element={<Bookings setLandingData={landingDetail} />}
          />
          <Route
            path={"/" + branchName + "/map"}
            element={<Map setLandingData={landingDetail} />}
          />

          <Route
            path={"/" + branchName + "/contactus"}
            element={<ContactUs />}
          />
          <Route
            path={"/" + branchName + "/bookingview/:id"}
            element={<BookingView data={landingDetail} branchDataRes={branchDataRes} />}
          />
          <Route
            path={"/" + branchName + "/roomthankyou/paymentsummary"}
            element={<RoomThankYouPage branchDataRes={branchDataRes} />}
          />
          <Route
            path={"/" + branchName + "/myaccount"}
            element={<MyAccount />}
          />
          <Route
            path={"/" + branchName + "/dashboard"}
            element={<Dashboard />}
          />
          {/* Redirect unknown routes to Home */}
          <Route path="*" element={<Navigate to={"/" + branchName} />} />
        </Routes>
        <Footer setFooterData={landingDetail} />
      </Router>
    </>
  );
}
